(function () {
  var root = document.querySelector('.pp-quiz');
  if (!root) return;
  var dataEl = root.querySelector('script[type="application/json"]');
  var PRODUCTS = {};
  try { PRODUCTS = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var STEPS = [
    { sub: 'Stap 1 van 3', q: 'Wat wil je doen?', opts: [
      { id: 'protect', l: 'Beschermen', s: 'Tegen water, vuil & vlekken' },
      { id: 'clean', l: 'Reinigen', s: 'Vlekken & aanslag verwijderen' },
      { id: 'fresh', l: 'Verfrissen', s: 'Geur neutraliseren' },
      { id: 'all', l: 'Alles-in-één', s: 'Complete routine' } ] },
    { sub: 'Stap 2 van 3', q: 'Welk materiaal?', opts: [
      { id: 'suede', l: 'Suède / nubuck', s: 'UGG-stijl, suède sneakers' },
      { id: 'textile', l: 'Textiel / mesh / canvas', s: 'Sneakers, sokken, tassen' },
      { id: 'leather', l: 'Glad / kunstleer', s: 'Leren schoenen & jassen' },
      { id: 'ugg', l: 'Sheepskin / UGG', s: "Echte UGG's & lamsvacht" },
      { id: 'mixed', l: 'Mix / weet ik niet', s: 'Verschillende materialen' } ] },
    { sub: 'Stap 3 van 3', q: 'Hoeveel wil je behandelen?', opts: [
      { id: 'few', l: '1–3 paar', s: '150 ml is genoeg' },
      { id: 'many', l: '4+ paar', s: '300 ml is voordeliger' },
      { id: 'household', l: 'Complete set / huishouden', s: 'Kit aanbevolen' } ] }
  ];

  function recommend(intent, material, volume) {
    var size = (volume === 'many' || volume === 'household') ? '300' : '150';
    if (intent === 'fresh') return { key: 'perfume', size: size, cross: ['p01'] };
    if (intent === 'clean') {
      if (material === 'leather') return { key: 'doek', size: 'def', cross: ['p02'] };
      return { key: 'clean', size: size, cross: ['p01'] };
    }
    if (intent === 'all') {
      if (material === 'ugg') return { key: 'uggkit', size: 'def', cross: ['brush'] };
      if (material === 'suede') return { key: 'suedekit', size: 'def', cross: ['perfume'] };
      return { key: 'sneakerkit', size: 'def', cross: ['perfume'] };
    }
    if (volume === 'household') {
      if (material === 'ugg') return { key: 'uggkit', size: 'def', cross: ['brush'] };
      if (material === 'suede') return { key: 'suedekit', size: 'def', cross: ['perfume'] };
      if (material === 'textile' || material === 'mixed') return { key: 'sneakerkit', size: 'def', cross: ['perfume'] };
    }
    if (material === 'leather') return { key: 'p02', size: size, cross: ['doek', 'brush'] };
    if (material === 'mixed') return { key: 'sneakerkit', size: 'def', cross: ['perfume'] };
    return { key: 'p01', size: size, cross: (material === 'ugg' ? ['brush'] : ['brush', 'clean']) };
  }

  function variantFor(p, size) {
    if (size === '150' && p.v150) return p.v150;
    if (size === '300' && p.v300) return p.v300;
    return p.vdef;
  }
  function sizeLabel(p, size) {
    if (size === '150' && p.v150) return '150 ml';
    if (size === '300' && p.v300) return '300 ml';
    return '';
  }
  function priceFor(p, size) {
    if (size === '150' && p.v150p) return p.v150p;
    if (size === '300' && p.v300p) return p.v300p;
    return p.vdefp || p.price;
  }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var stage = root.querySelector('[data-quiz-stage]');
  var dots = root.querySelector('[data-quiz-dots]');
  var toast = root.querySelector('[data-quiz-toast]'), toastT;
  var step = 0, answers = [];

  function open() { step = 0; answers = []; render(); root.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function close() { root.hidden = true; document.documentElement.style.overflow = ''; }

  function renderDots() {
    dots.innerHTML = '';
    if (answers.length >= 3) { dots.style.display = 'none'; return; }
    dots.style.display = 'flex';
    for (var i = 0; i < 3; i++) {
      var s = document.createElement('span');
      if (i < step) s.className = 'on';
      if (i === step) s.className = 'on cur';
      dots.appendChild(s);
    }
  }

  function render() {
    renderDots();
    var st = STEPS[step];
    var html = '<div class="pp-quiz-sub">' + st.sub + '</div><h2 class="pp-quiz-q">' + st.q + '</h2><div class="pp-quiz-opts">';
    st.opts.forEach(function (o) {
      html += '<button type="button" class="pp-quiz-opt" data-pick="' + o.id + '"><span class="l">' + o.l + '</span><span class="s">' + o.s + '</span></button>';
    });
    html += '</div>';
    if (step > 0) html += '<button type="button" class="pp-quiz-back" data-back>← Vorige</button>';
    stage.innerHTML = html;
  }

  function renderResult() {
    dots.style.display = 'none';
    var r = recommend(answers[0], answers[1], answers[2]);
    var p = PRODUCTS[r.key];
    if (!p) { stage.innerHTML = '<p>Geen aanbeveling gevonden.</p>'; return; }
    var vid = variantFor(p, r.size);
    var slabel = sizeLabel(p, r.size);
    var sprice = priceFor(p, r.size);
    var html = '<div class="pp-quiz-sub">Onze aanbeveling</div><div class="pp-quiz-res">';
    html += '<div class="img"><img src="' + p.img + '" alt="' + esc(p.name) + '"></div>';
    html += '<div><h3 class="pp-quiz-rname">' + esc(p.name) + '</h3><p class="pp-quiz-reason">' + esc(p.reason) + '</p>';
    html += '<div><span class="pp-quiz-price">' + sprice + '</span>' + (slabel ? '<span class="pp-quiz-size">' + slabel + '</span>' : '') + '</div>';
    html += '<button type="button" class="pp-quiz-btn" data-add="' + vid + '">In winkelwagen</button>';
    html += '<button type="button" class="pp-quiz-restart" data-restart>↺ Opnieuw beginnen</button></div></div>';
    if (r.cross && r.cross.length) {
      html += '<div class="pp-quiz-cross"><div class="lbl">Vaak samen gekocht</div><div class="row">';
      r.cross.forEach(function (ck) {
        var c = PRODUCTS[ck]; if (!c) return;
        html += '<div class="pp-quiz-citem"><img src="' + c.img + '" alt="' + esc(c.name) + '"><div><div class="n">' + esc(c.name) + '</div><div class="p">vanaf ' + c.price + '</div></div><button type="button" class="pp-quiz-cadd" data-add="' + c.vdef + '" aria-label="Toevoegen">+</button></div>';
      });
      html += '</div></div>';
    }
    stage.innerHTML = html;
  }

  function addToCart(vid, btn) {
    if (!vid || !window.fetch) return;
    var url = root.getAttribute('data-cart-add-url') || '/cart/add';
    if (btn) btn.disabled = true;
    fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble,header', sections_url: window.location.pathname }) })
      .then(function (rr) { if (!rr.ok) throw 0; return rr.json(); })
      .then(function (add) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (rr) { return rr.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'pp-quiz', data: { source: 'product-form-component', itemCount: cart.item_count, sections: add.sections || {} } } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (toast) { toast.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 2200); }
          if (btn) btn.disabled = false;
        });
      }).catch(function () { if (btn) btn.disabled = false; });
  }

  stage.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-pick]');
    if (pick) { answers[step] = pick.getAttribute('data-pick'); if (step < 2) { step++; render(); } else { renderResult(); } return; }
    var back = e.target.closest('[data-back]');
    if (back) { if (step > 0) { step--; answers = answers.slice(0, step); render(); } return; }
    var restart = e.target.closest('[data-restart]');
    if (restart) { step = 0; answers = []; render(); return; }
    var add = e.target.closest('[data-add]');
    if (add) { addToCart(add.getAttribute('data-add'), add); }
  });

  root.querySelectorAll('[data-quiz-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-open-quiz]')) { e.preventDefault(); open(); } });
  document.addEventListener('pp:openquiz', open);
  window.ppOpenQuiz = open;
})();
